import * as m from "../../es2015/plugins/timeline";
window.am4plugins_timeline = m;


//////////////////
// WEBPACK FOOTER
// ./plugins/timeline.js
// module id = null
// module chunks = 